// This file is shared between SSR and none SSR pages, so we need to check a few things.

import _ from 'lodash'
import qs from 'qs'
import { createContext } from 'react'

// Default, for when the server provides the values
let BrandContext = createContext(null)

// For client side rendered pages
if (typeof window !== 'undefined' && window.brandConfig) {
  // Grab from the URL if we need to
  const urlParams = qs.parse(_.get(window, 'location.search', '').substring(1))

  // Grab all the config from the window and merge together
  const brandContent = _.get(window, 'brandReply.brands[0]', {})
  const brandConfig = Object.assign({}, brandContent, window.brandConfig)

  BrandContext = createContext({
    agent: window.agent || urlParams.agent,
    brandConfig,
    isCallCentre: brandConfig.consumerType === 'callCentre'
  })
}

export default BrandContext
